import { FC, useEffect, useState } from 'react';
import V2Container from '@/common/components/Data/V2Container';
import V2Drawer from '@/common/components/Feedback/V2Drawer';
import { getTaskInfo } from '@/common/api/expandStore/expansiontask';
import { Spin } from 'antd';
import TaskDetail from '@/common/components/business/ExpandStore/TaskDeatil';
import styles from './index.module.less';
import { getApprovalDetail } from '@/common/api/expandStore/approveworkbench';
import SkeletonDetail from '@/common/components/Skeleton/SkeletonDetail';
import Header from './components/Header';
import { useMethods } from '@lhb/hook';

interface Props {
  /** 是否打开 */
  open: boolean;
  /** 控制是否打开 */
  setOpen: Function;
  /** 拓店任务Id*/
  id;
  /** 是否拓店任务历史详情 */
  isHistory?: boolean;
  /** 是否隐藏操作按钮 */
  hideOperate?: boolean;
  /** 是否隐藏加盟商唯一标识字段 */
  hideFranchiseeUniqueId?: boolean;
  // 刷新外层调用方处理（通常是页面）
  outterRefresh?: Function;
}

/**
 * 拓店任务：加盟（益禾堂、非益禾堂）-详情抽屉
 * @Description
 * 1109 标准版数据迁移引用该组件，显示拓店任务详情内容
 */
const TaskDetailDrawer: FC<Props> = ({
  open,
  setOpen,
  id,
  isHistory = false,
  hideOperate = false,
  hideFranchiseeUniqueId = false,
  outterRefresh,
}) => {

  const [mainHeight, setMainHeight] = useState<number>(0);
  mainHeight;
  const [detail, setDetail] = useState<any>({}); // 拓店任务详情信息
  const [loading, setLoading] = useState<boolean>(false); // 加载中
  const [refresh, setRefresh] = useState<boolean>(false); // 刷新
  const [approvalDetail, setApprovalDetail] = useState<any>(null);// 审批详情
  const [loadingSk, setLoadingSk] = useState<boolean>(true); // 骨架屏

  useEffect(() => {
    if (!id && !refresh) return;
    setLoadingSk(true);
    open && methods.getTaskDetail();
    // 非打开抽屉时初次请求，是操作后刷新时，同时回调刷新外层
    (refresh && outterRefresh) && outterRefresh();
  }, [id, refresh, open]);

  useEffect(() => {
    if (!open) setDetail({}); // 解决打开下个详情时请求的还是前个任务id的问题
  }, [open]);

  useEffect(() => {
    methods.getApprovalDetailInfo();
  }, [detail?.approvalId]);

  const methods = useMethods({

    /**
     * @description 获取拓店任务详情
     */
    getTaskDetail: () => {
      setLoading(true);
      try {
        getTaskInfo({ id }).then((res) => {
          setDetail(res);
          setRefresh(false); // 刷新结束
          setLoading(false);
          // res && setLoadingSk(false);
        });
      } catch (error) {
        setRefresh(false);
        setLoading(false);
        // setLoadingSk(false);
      }
      setLoadingSk(false);

    },

    /**
     * @description 获取审批详情
     */
    getApprovalDetailInfo: async() => {
      if (!detail?.approvalId) {
        setApprovalDetail({});
        return;
      }
      const data = await getApprovalDetail({ id: detail?.approvalId });
      setApprovalDetail(data);
    },

  });

  return (
    <>
      <V2Drawer
        bodyStyle={{ padding: 0, }}
        destroyOnClose
        open={open}
        onClose={() => setOpen(false)}
      >
        {
          loadingSk
            ? <SkeletonDetail/>
            : <V2Container
              // 容器上下padding 32， 所以减去就是64
              style={{ height: 'calc(100vh - 64px)' }}
              emitMainHeight={h => setMainHeight(h)}
              className={styles.container}
              extraContent={{
                top: <Header
                  detail={detail}
                  isHistory={isHistory}
                  hideOperate={hideOperate}
                  onRefresh={() => setRefresh(true)}
                />,
              }}
            >
              <div className={'pb-16 pl-40 pr-40'}>
                <Spin spinning={loading}>
                  <TaskDetail
                    // mainHeight={mainHeight}
                    detail={detail}
                    aprDetail={approvalDetail}
                    refresh={() => setRefresh(true)}
                    open={open}
                    hideOperate={hideOperate}
                    hideFranchiseeUniqueId={hideFranchiseeUniqueId}
                  />
                </Spin>
              </div>

            </V2Container>
        }

      </V2Drawer>
    </>
  );
};
export default TaskDetailDrawer;
